export function isPublicationLocked(publication) {
    if (!publication) return true;

    if (publication.hasPublisheeAccess) return false;

    if (["Draft", "Submitted", "Returned", "Processed"].includes(publication.status)) return false;

    return true;
}

export function isPublishingToMPIWholeFarmDataProject(publishToIds = []) {
    return publishToIds.length === 1 && publishToIds[0] === "b935c5af-5237-4a5a-b3cc-7a6a36372a1f";
}
